import React, { useMemo } from "react";
import PageScaffold from "../../components/PageScaffold";
import { Box } from "@chakra-ui/react";
import { useUserDetailsContext } from "../../context/userDetailsContext";

const RETOOL_BASE_URL =
  "https://garaaz.retool.com/apps/Order%20%26%20Invoice%20Dashboard";

const Reports = () => {
  const { _id } = useUserDetailsContext();
  const iframeSrc = useMemo(
    () =>
      _id
        ? `${RETOOL_BASE_URL}?mongoUserId=${encodeURIComponent(_id)}`
        : null,
    [_id]
  );

  return (
    <PageScaffold title="Reports" isHeaderVisible={true}>
      <Box height="calc(100vh - 64px)" width="100%">
        {iframeSrc && (
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="Reports"
          />
        )}
      </Box>
    </PageScaffold>
  );
};

export default Reports;
